import { Component, OnInit, ViewEncapsulation, Output, Input, EventEmitter } from '@angular/core';

@Component({
  templateUrl: './step-indicator.component.html',
  selector: 'step-indicator',
  styleUrls: ['./step-indicator.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class StepIndicatorComponent implements OnInit {
  @Output() stepsChange: EventEmitter<Array<any>>;
  public _steps: Array<any> = [];
  @Input('steps')
  public set steps(value: Array<any>) {
    this._steps = value;
    console.log('steps');
    console.log(value);
    this.stepsChange.emit(value);
  }
  public get steps(): Array<any> {
    return this._steps;
  }

  public _currentValidStep: number = 0;
  @Input('currentValidStep')
  public set currentValidStep(value: number) {
    this._currentValidStep = value;
  }
  public get currentValidStep(): number {
    return this._currentValidStep;
  }

  @Output() activeIndexChange: EventEmitter<number>;
  public _activeIndex: number = 0;
  @Input('activeIndex')
  public set activeIndex(value: number) {
    this._activeIndex = value;
    console.log('activeIndex');
    console.log(value);
    this.activeIndexChange.emit(value);
  }
  public get activeIndex(): number {
    return this._activeIndex;
  }

  public gotoStep(step) {
    if (step <= this.currentValidStep) {
      console.log('Step: ' + step);
      this.activeIndexChange.emit(step);
    }
  }

  constructor() {
    this.activeIndexChange = new EventEmitter<number>();
    this.stepsChange = new EventEmitter<Array<any>>();
  }

  ngOnInit() {}
}
